<ion-row class="search-box-wrapper">
  <ion-col class="input-wrapper">
    <ion-input
      #input
      fill="outline"
      class="input"
      [disabled]="isDisabled"
      [placeholder]="DISP_CONSTANTS.SEARCH_HERE"
      [maxlength]="20"
      (ionFocus)="showCancelButton = true"
      (ionBlur)="showCancelButton = false"
      (ionInput)="sendTextChange($event)"
    ></ion-input>
    <div
      class="clear-search-text-icons"
      onkeypress="clearSearch()"
      (click)="clearSearch()"
    >
      <img
        alt="clear-search"
        [src]="showCancelButton ? IMAGES.CLEAR : IMAGES.SEARCH"
        [ngClass]="{ 'active-click': showCancelButton }"
      />
    </div>
  </ion-col>
</ion-row>
